const iconMap: Record<string, any> = {
  'arrow-extern': (): any => import('@/assets/svg/icons/arrow-extern.svg'),
  'arrow-header': (): any => import('@/assets/svg/icons/arrow-header.svg'),
  'arrow-left': (): any => import('@/assets/svg/icons/arrow-left.svg'),
  'arrow-right': (): any => import('@/assets/svg/icons/arrow-right.svg'),
  'chevron-down': (): any => import('@/assets/svg/icons/chevron-down.svg'),
  'logo-abbruch': (): any => import('@/assets/svg/icons/logos/logo-abbruch.svg'),
  'logo-baustoffe': (): any => import('@/assets/svg/icons/logos/logo-baustoffe-recycling.svg'),
  'logo-bauwerksanierung': (): any => import('@/assets/svg/icons/logos/logo-bauwerksanierung.svg'),
  'logo-beundentkiesung': (): any => import('@/assets/svg/icons/logos/logo-beundentkiesung.svg'),
  'logo-default': (): any => import('@/assets/svg/icons/logos/logo-default.svg'),
  'logo-deponiebau': (): any => import('@/assets/svg/icons/logos/logo-deponiebau.svg'),
  'logo-energietechnik': (): any => import('@/assets/svg/icons/logos/logo-energietechnik.svg'),
  'logo-entsorgung': (): any => import('@/assets/svg/icons/logos/logo-entsorgung.svg'),
  'logo-hochundtiefbau': (): any => import('@/assets/svg/icons/logos/logo-hochundtiefbau.svg'),
  'logo-holzsystembau': (): any => import('@/assets/svg/icons/logos/logo-holzsystembau.svg'),
  'logo-immobilien': (): any => import('@/assets/svg/icons/logos/logo-immobilien.svg'),
  'logo-kanalsanierung': (): any => import('@/assets/svg/icons/logos/logo-kanalsanierung.svg'),
  'logo-logistik': (): any => import('@/assets/svg/icons/logos/logo-logistik.svg'),
  'logo-mineralstoffbehandlung': (): any => import('@/assets/svg/icons/logos/logo-mineralstoffbehandlung.svg'),
  'logo-netzbau': (): any => import('@/assets/svg/icons/logos/logo-netzbau.svg'),
  'logo-projektentwicklung': (): any => import('@/assets/svg/icons/logos/logo-projektentwicklung.svg'),
  'logo-recycling': (): any => import('@/assets/svg/icons/logos/logo-baustoffe-recycling.svg'),
  'logo-schluesselfertigbau': (): any => import('@/assets/svg/icons/logos/logo-schluesselfertigbau.svg'),
  'logo-umwelt': (): any => import('@/assets/svg/icons/logos/logo-umwelt.svg'),
  'logo-umweltsanierung': (): any => import('@/assets/svg/icons/logos/logo-umweltsanierung.svg'),
  check: (): any => import('@/assets/svg/icons/check.svg'),
  close: (): any => import('@/assets/svg/icons/close.svg'),
  download: (): any => import('@/assets/svg/icons/download.svg'),
  facebook: (): any => import('@/assets/svg/icons/facebook.svg'),
  globe: (): any => import('@/assets/svg/icons/globe.svg'),
  instagram: (): any => import('@/assets/svg/icons/instagram.svg'),
  kununu: (): any => import('@/assets/svg/icons/kununu.svg'),
  lineShape: (): any => import('@/assets/svg/icons/line-shape.svg'),
  linkedin: (): any => import('@/assets/svg/icons/linkedin.svg'),
  logo: (): any => import('@/assets/svg/icons/logo.svg'),
  logoExample: (): any => import('@/assets/svg/icons/logo-example.svg'),
  mail: (): any => import('@/assets/svg/icons/mail.svg'),
  map: (): any => import('@/assets/svg/icons/map.svg'),
  menu: (): any => import('@/assets/svg/icons/menu.svg'),
  minus: (): any => import('@/assets/svg/icons/minus.svg'),
  paper: (): any => import('@/assets/svg/icons/paper.svg'),
  phone: (): any => import('@/assets/svg/icons/phone.svg'),
  playButton: (): any => import('@/assets/svg/icons/playButton.svg'),
  shapeEven: (): any => import('@/assets/svg/icons/shape-even.svg'),
  shapeWide: (): any => import('@/assets/svg/icons/shape-wide.svg'),
  shapeWideVariant: (): any => import('@/assets/svg/icons/shape-wide-variant.svg'),
  shapeWideVariant2: (): any => import('@/assets/svg/icons/shape-wide-variant2.svg'),
  tiktok: (): any => import('@/assets/svg/icons/tiktok.svg'),
  xing: (): any => import('@/assets/svg/icons/xing.svg'),
  youtube: (): any => import('@/assets/svg/icons/youtube.svg'),
};

export default iconMap;
